import React from 'react';
import DefaultUi from '../DefaultUi';
import HTMLComponent from '../HTMLComponent';
import MarkdownComponent from '../MarkdownComponent';
import get_bundle from '../../domain/get_bundle';
import User from '../../domain/User';
import Color from '../../domain/Color';
import Locale from '../../domain/Locale';
import Gender from '../../domain/Gender';
import Com_Locale from '../../domain/Com_Locale';
import countries from '../../domain/countries';
import getConditions from '../../util/getConditions';
import getPolicy from '../../util/getPolicy';
import t from 'tcomb-form';
import { props } from 'tcomb-react';
import template from 'lodash/string/template';

@props({
  districts: t.Arr,
  loadDistricts: t.Func,
  doUpdateAccount: t.Func,
  locale: t.Obj,
  user: User,
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  doAcceptCookies: t.Func,
  goAccount: t.Func,
  goChangePassword: t.Func,
  goPurchases: t.Func,
  doLogout: t.Func,
  message: t.maybe(t.ReactElement)
})
export default class Account extends React.Component {

  constructor(...args) {
    super(...args);
    this.districts = this.props.districts;
    const value = this.getValue();
    this.state = {
      value,
      options: this.getOptions(value)
    };
  }

  onChange = (value) => {
    if (value.country) {
      if (value.country !== this.state.value.country) {
        this.props.loadDistricts(value.country, (districts) => {
          this.districts = districts;
          value.district = null;
          this.setState({
            value,
            options: this.getOptions(value)
          });
        });
      } else {
        this.setState({
          value
        });
      }
    } else {
      this.setState({
        value,
        options: this.getOptions(value)
      });
    }
  }

  onSubmit = (evt) => {
    evt.preventDefault();
    const value = this.refs.form.getValue();

    if (value) {
      this.props.doUpdateAccount(
        value.name,
        value.surname,
        value.gender,
        value.birth_date.getTime(),
        value.country,
        value.district,
        value.zip,
        value.com_locale
      );
    }
  }

  getCountriesOptions() {
    return countries.to_options(this.props.locale).map((country) => {
      return {
        value: country[0],
        text: country[1]
      };
    });
  }

  getGenderOptions() {
    return get_bundle(this.props.locale).user.gender_options.map((option) => {
      return {
        value: option[0],
        text: option[1]
      };
    });
  }

  getComLocaleOptions() {
    const locale = this.props.locale;
    const options = [];
    for ( const com_locale in Com_Locale.meta.map) {
      let l = Locale.of(com_locale);
      options.push({
        value: com_locale,
        text: locale.display_language(l.language) + ' (' + locale.display_country(l.country) + ')'
      });
    }
    return options;
  }

  getDistrictsOptions(country) {
    if (!country) {
      return [];
    }

    return this.districts.map((district) => {
      return {
        value: district[0],
        text: district[1]
      };
    });
  }

  getDistrictsArray() {
    return this.districts.map((district) => {
      return district[0];
    });
  }

  getCountriesArray() {
    const countriesElements = [];
    for(const country in countries.data) {
      countriesElements.push(country);
    }
    return countriesElements;
  };

  getFormType() {

    const districtsArray = this.getDistrictsArray();
    const District = t.enums.of(districtsArray);

    const countriesArray = this.getCountriesArray();
    const CountryDomain = t.enums.of(countriesArray);

    return  t.struct({
      name: t.maybe(t.Str),
      surname: t.maybe(t.Str),
      gender: Gender,
      birth_date: t.Dat,
      country: CountryDomain,
      district: District,
      zip: t.Str,
      com_locale: Com_Locale,
      email: t.Str,
      mobile: t.Str
    }, 'Account');
  }


  getOptions(value) {
    const locale = this.props.locale;
    const bundle = get_bundle(locale).user;

    return {
      config: {
        horizontal: {
          md: [3, 9],
          sm: [6, 6]
        }
      },
      fields: {
        name: {
          label: bundle.name
        },
        surname: {
          label: bundle.surname
        },
        gender: {
          label: bundle.gender,
          options: this.getGenderOptions()
        },
        birth_date: {
          label: bundle.birth_date,
          order: locale.getTcombFormDateOrder()
        },
        country: {
          label: bundle.country,
          options: this.getCountriesOptions(),
          help: bundle.country_hint
        },
        district: {
          label: bundle.district,
          options: this.getDistrictsOptions(value.country)
        },
        zip: {
          label: bundle.zip
        },
        com_locale: {
          label: bundle.locale,
          options: this.getComLocaleOptions(),
          help: bundle.locale_hint
        },
        email: {
          label: bundle.email,
          type: 'static'
        },
        mobile: {
          label: bundle.mobile,
          type: 'static'
        }
      }
    };
  };

  getValue() {
    const user = this.props.user;

    return {
      name: user.name,
      surname: user.surname,
      gender: user.gender,
      birth_date: new Date(user.birth_date),
      country: user.country,
      district: user.district,
      zip: user.zip,
      com_locale: user.com_locale.toJSON(),
      email: user.email,
      mobile: user.mobile
    };
  }

  getHelp() {
    return (
      <MarkdownComponent>
        {get_bundle(this.props.locale)['account']['help']}
      </MarkdownComponent>
    );
  }

  render() {
    const { locale } = this.props;
    const bundle = get_bundle(locale).account;

    const btnStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };

    return (
      <DefaultUi id="account" title={bundle.title} themeBgColor={this.props.themeBgColor} themeBgFontColor={this.props.themeBgFontColor}>
        <div className="cols">
          <div className="large-30 medium-100">
            <div className="cell">
              <div className="alert info help">
                { this.getHelp() }
              </div>
            </div>
          </div>
          <div className="large-70 medium-100">
            <div className="cell">
              { this.props.message }
              <form onSubmit={this.onSubmit}>
                <t.form.Form
                  ref="form"
                  type={this.getFormType()}
                  options={this.state.options}
                  value={this.state.value}
                  onChange={this.onChange} />
                <button className="large-left-30p small-left-0p btn" style={btnStyle}>{bundle.do_save}</button>
                <div className="large-left-30p small-left-0p disclaimer">
                  <small>
                    <HTMLComponent>
                      {template(bundle.disclaimer)({
                        conditions: getConditions(locale),
                        policy: getPolicy(locale)
                      })}
                      </HTMLComponent>
                  </small>
                </div>
             </form>
            </div>
          </div>
        </div>
      </DefaultUi>
    );
  }
}





/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/content/Account.js
 **/